/* WOOLY — cart drawer controller.
   Fetches /cart.js, re-renders body + footer, slides in.
   window.openCartDrawer() is exposed for ATC buttons. */
(function () {
  'use strict';

  var SHAMPOO = 'wooly-hair-colour-shampoo';

  var root, panel, body, foot, countEl;

  function init() {
    root = document.getElementById('wly-cart-drawer');
    if (!root) return;
    panel = root.querySelector('.wly-drawer__panel');
    body = root.querySelector('[data-drawer-body]');
    foot = root.querySelector('[data-drawer-foot]');
    countEl = root.querySelector('[data-drawer-count]');

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-overlay]') || e.target.closest('[data-drawer-close]')) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }
      var dec = e.target.closest('[data-qty-dec]');
      var inc = e.target.closest('[data-qty-inc]');
      var rem = e.target.closest('[data-remove]');
      var coupon = e.target.closest('.wly-drawer__coupon-btn');
      if (dec) { e.preventDefault(); changeByKey(dec.getAttribute('data-key'), -1); }
      else if (inc) { e.preventDefault(); changeByKey(inc.getAttribute('data-key'), 1); }
      else if (rem) { e.preventDefault(); setByKey(rem.getAttribute('data-key'), 0); }
      else if (coupon) {
        e.preventDefault();
        var row = coupon.closest('.wly-drawer__coupon-row');
        var input = row && row.querySelector('.wly-drawer__coupon-input');
        var code = input ? (input.value || '').trim() : '';
        if (!code) { if (input) input.focus(); return; }
        window.location.href = '/checkout?discount=' + encodeURIComponent(code);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeCartDrawer();
    });
  }

  /* ---------- money ---------- */
  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    return '₹' + n.toLocaleString('en-IN');
  }

  /* ---------- data ---------- */
  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Prefetch cart on page load and cache it (stale-while-revalidate).
  var _cartCache = null;
  var _cartCacheTime = 0;
  var CACHE_TTL = 5000; // instant-paint freshness window

  function setCartCache(cart) {
    _cartCache = cart;
    _cartCacheTime = Date.now();
    return cart;
  }
  // Invalidate after a mutation (e.g. add-to-cart) so the next open fetches
  // fresh and never paints a stale/empty cart.
  function invalidateCartCache() { _cartCache = null; _cartCacheTime = 0; }

  // Warm cache on page load so the first drawer-open can paint instantly.
  document.addEventListener('DOMContentLoaded', function() {
    getCart().then(setCartCache);
  });

  function lineQtyMap(cart) {
    var m = {};
    cart.items.forEach(function (it, i) { m[it.key] = { line: i + 1, qty: it.quantity, variant_id: it.variant_id }; });
    return m;
  }

  /* ---------- render ---------- */
  function render(cart) {
    if (countEl) countEl.textContent = cart.item_count;

    if (!cart.items.length) {
      body.innerHTML =
        '<div class="wly-drawer__empty">' +
        '<p class="wly-drawer__empty-msg">your bag is empty.</p>' +
        '<a href="/products/' + SHAMPOO + '" class="wly-drawer__shop">shop now &rarr;</a>' +
        '</div>';
      foot.innerHTML = '';
      return;
    }

    var savings = 0;
    var items = cart.items.map(function (it) {
      var cmp = it.compare_at_price || 0;
      if (cmp > it.final_price) savings += (cmp - it.final_price) * it.quantity;
      var img = it.image
        ? '<img class="wly-drawer__img" src="' + it.image + '" alt="" width="72" height="72" loading="lazy">'
        : '<span class="wly-drawer__img wly-drawer__img--ph"></span>';
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1)
        ? '<span class="wly-drawer__variant">' + esc(it.variant_title) + '</span>' : '';
      return '' +
        '<div class="wly-drawer__item">' +
          '<a href="' + it.url + '" class="wly-drawer__media">' + img + '</a>' +
          '<div class="wly-drawer__meta">' +
            '<a href="' + it.url + '" class="wly-drawer__name">' + esc(it.product_title) + '</a>' +
            variant +
            '<span class="wly-drawer__price">' + money(it.final_line_price) + '</span>' +
            '<div class="wly-drawer__qty">' +
              '<button type="button" class="wly-drawer__qty-btn" data-qty-dec data-key="' + it.key + '" aria-label="Decrease">&minus;</button>' +
              '<span class="wly-drawer__qty-val">' + it.quantity + '</span>' +
              '<button type="button" class="wly-drawer__qty-btn" data-qty-inc data-key="' + it.key + '" aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="wly-drawer__remove" data-remove data-key="' + it.key + '" aria-label="Remove">&times;</button>' +
        '</div>';
    }).join('');

    body.innerHTML = '<div class="wly-drawer__items">' + items + '</div>';

    var savingsRow = savings > 0
      ? '<p class="wly-drawer__savings">&#127881; You\'re saving ' + money(savings) + '</p>' : '';
    var prepaid = Math.max(0, cart.total_price - 10000);
    var cod = cart.total_price + 9900;
    var saveBadge = cart.total_price > 20000
      ? ' <span class="wly-drawer__calc-save">SAVE ₹199 vs COD</span>' : '';
    var calcRows = '' +
      '<div class="wly-drawer__calc">' +
        '<div class="wly-drawer__calc-row">' +
          '<span class="wly-drawer__calc-label">&#128179; If paying UPI/Card:</span>' +
          '<span class="wly-drawer__calc-val">' + money(prepaid) + saveBadge + '</span>' +
        '</div>' +
        '<div class="wly-drawer__calc-row wly-drawer__calc-row--cod">' +
          '<span class="wly-drawer__calc-label">&#128230; If COD:</span>' +
          '<span class="wly-drawer__calc-val">' + money(cod) + '</span>' +
        '</div>' +
      '</div>';
    foot.innerHTML = '' +
      '<div class="wly-drawer__sub"><span>subtotal</span>' +
        '<span class="wly-drawer__sub-val">' + money(cart.total_price) + '</span></div>' +
      savingsRow +
      '<div class="wly-drawer__pay">' +
        '<span class="wly-drawer__pay-pill">UPI</span>' +
        '<span class="wly-drawer__pay-pill">RuPay</span>' +
        '<span class="wly-drawer__pay-pill">COD</span>' +
      '</div>' +
      calcRows +
      '<div class="wly-drawer__coupon">' +
        '<div class="wly-drawer__coupon-row">' +
          '<input type="text" class="wly-drawer__coupon-input" placeholder="Coupon code" aria-label="Coupon code">' +
          '<button type="button" class="wly-drawer__coupon-btn">Apply</button>' +
        '</div>' +
      '</div>' +
      '<div class="shiprocket-headless" data-type="mini-cart"></div>'+
      '<a href="/checkout" class="wly-drawer__checkout">checkout</a>' +
      '<button type="button" class="wly-drawer__continue" data-drawer-close>continue shopping</button>';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- mutations ---------- */
  function refresh() {
    // Stale-while-revalidate: paint a fresh-enough cache instantly, then always
    // fetch the authoritative cart and re-render so contents are never stale.
    var now = Date.now();
    if (_cartCache && (now - _cartCacheTime) < CACHE_TTL) render(_cartCache);
    return getCart().then(function (cart) { render(setCartCache(cart)); return cart; });
  }

  function changeByKey(key, delta) {
    getCart().then(function (cart) {
      var m = lineQtyMap(cart)[key];
      if (!m) return;
      const SHAMPOO_VARIANTS = [43298968010800, 43298968043568, 43298968076336];
      const maxQty = SHAMPOO_VARIANTS.includes(Number(m.variant_id)) ? 1 : 99;
      return postChange(m.line, Math.min(maxQty, Math.max(0, m.qty + delta)));
    });
  }
  function setByKey(key, qty) {
    getCart().then(function (cart) {
      var m = lineQtyMap(cart)[key];
      if (!m) return;
      return postChange(m.line, qty);
    });
  }
  function postChange(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { render(setCartCache(cart)); });
  }

  /* ---------- open / close ---------- */
  function openCartDrawer() {
    if (!root) return;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    refresh();
  }
  function closeCartDrawer() {
    if (!root) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.invalidateCartCache = invalidateCartCache;
})();
